import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState } from 'react';
import useScroll from '../use-scroll';
import behaviours from './behaviours';

var noop = function noop() {
  return {};
};

export var useBehaviour = function useBehaviour(props) {
  var _useState = useState(props),
      _useState2 = _slicedToArray(_useState, 2),
      _useState2$ = _useState2[0],
      behaviour = _useState2$.behaviour,
      placement = _useState2$.placement,
      navbarRef = _useState2$.navbarRef,
      setBehaviourProps = _useState2[1];

  var scroll = useScroll();
  var operation = behaviours[behaviour] || noop;

  var _operation = operation({
    navbarRef: navbarRef,
    placement: placement,
    scroll: scroll
  }),
      className = _operation.className,
      attributes = _operation.attributes;

  return [{
    className: className,
    attributes: attributes
  }, setBehaviourProps];
};
export default useBehaviour;